import React from 'react';
import { useUpdateCourseMapping, UpdateCourseMappingPayload } from '../../data/useUpdateCourseMapping';

export function useUpdateCourseMappingActivity() {
  const { updateCourseMapping } = useUpdateCourseMapping();
  const [isBusy, setIsBusy] = React.useState(false);

  async function update(payload: UpdateCourseMappingPayload) {
    setIsBusy(true);
    return updateCourseMapping(payload)
      .then((result) => result)
      .finally(() => setIsBusy(false));
  }

  return {
    isBusy,
    update,
  };
}
